import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../../hooks/auth/useAuth';
import { Locale } from '../../../i18n';
import { SUPPORT_EMAIL } from '../../constants/emails.constant';
import generateEmailBody from './generateEmailBody';

type RestrictedAccessCardProps = {
  text: string;
};

const RestrictedAccessCard = ({ text }: RestrictedAccessCardProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const { user } = useAuth();

  const handleEmailClick = () => {
    const emailSubject = t('emails.upgradeInquiry.subject');
    let emailBody = generateEmailBody(user, language as Locale);

    // Encode the email body for the mailto link
    emailBody = encodeURIComponent(emailBody);

    // Create the mailto link with the recipient, subject, and body
    const mailtoLink = `mailto:${SUPPORT_EMAIL}?subject=${emailSubject}&body=${emailBody}`;

    // Open the user's default email client with the mailto link
    window.location.href = mailtoLink;
  };

  return (
    <div className='w-full h-full flex absolute'>
      <div className='w-full h-full bg-gray-900 p-1 border-round-2xl flex absolute z-10 opacity-30' />

      <div
        className='flex p-4 bg-white border-round-2xl absolute shadow-4 flex-column gap-4 md:gap-2 left-50 w-full md:w-auto'
        style={{ translate: '-50% 100px' }}
      >
        <h4 className='justify-content-center flex w-full'>{t('restrictedAccessCard.title')}</h4>

        <span className='w-full flex'>{text}</span>

        <span>{t('restrictedAccessCard.text2.part1')}</span>

        <div className='flex flex-wrap gap-1'>
          <Button
            link
            label={t('restrictedAccessCard.text2.clickHere')}
            className='p-0'
            onClick={handleEmailClick}
          />
          <span>{t('restrictedAccessCard.text2.part2')}</span>
        </div>
      </div>
    </div>
  );
};

export default RestrictedAccessCard;
